// import RNFetchBlob from 'rn-fetch-blob';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {MQ_ENDPOINTS} from '~/constants';
import {UploadImageModules} from '~/redux/apps/types';
import {AppDispatch} from '~/redux/root-store';
import AppError from '~/utils/error-handler';
import request from '~/utils/request';
import {ThunkApi} from '~/utils/thunk-api';
import {FetchParams, PostParams, PutParams, RejectErrorValue} from '~/utils/thunk-api/type';

export interface FetchAppsParams extends FetchParams {}

export interface UploadFileToServer extends PostParams {
  data: {
    type: UploadImageModules;
    fileName: string;
    filePath: string;
  };
}

export interface UpdateAppParams extends PutParams {
  data: {};
  id: number;
}

const thunk = new ThunkApi('app');

// @Refer: Academy admin code base
export const uploadFile = createAsyncThunk<
  {accessUrl: string},
  {module: string; fileName: string; file: File; endpoint?: string},
  {dispatch: AppDispatch; rejectValue: RejectErrorValue}
>('file/upload', async ({module, fileName, file, endpoint}, {rejectWithValue}) => {
  try {
    const formData = new FormData();
    formData.append('file', file, fileName);
    formData.append('module', module);

    const res = await request.post(endpoint || MQ_ENDPOINTS.FILE_UPLOAD, formData);
    // @ts-ignore
    const {url: accessUrl} = res.data.data;

    return {accessUrl};
  } catch (e) {
    new AppError(e);
    return rejectWithValue({errMsg: 'Can not upload file!'} as RejectErrorValue);
  }
});

// export const uploadFileToServer = thunk.misc<UploadFileToServer, UploadFileToServerApiItem>(
//   'upload',
//   async ({data: {fileName, filePath, module}}, dispatch, onError, getState) => {
//     try {
//       const resp = await RNFetchBlob.fetch(
//         'POST',
//         appConfig.api.url + ENDPOINTS.UPLOAD_FILE,
//         {
//           Authorization: `Bearer ${getState().auth?.token}`,
//           // this is required, otherwise it won't be process as a multipart/form-data request
//           'Content-Type': 'multipart/form-data',
//         },
//         [
//           {
//             name: 'file',
//             filename: fileName,
//             data: RNFetchBlob.wrap(decodeURIComponent(filePath.replace('file://', ''))),
//           },
//           {name: 'module', data: module},
//         ],
//       );
//       return resp?.json()?.data || ({} as UploadFileToServerApiItem);
//     } catch (e) {
//       new AppError(e, '', {
//         debugMessage: `Upload photo failed!:
//          If you got "SyntaxError: JSON Parse error: Unexpected token: <", usually it's because of: 413 Entity too large`,
//       });
//       onError(e);
//     }
//     return {} as UploadFileToServerApiItem;
//   },
// );
// export const fetchApps = thunk.fetch<FetchAppsParams, AppApiItem[]>(ENDPOINTS.APPS, '', {
//   withoutNormalize: true,
// });
// export const updateApp = thunk.put<UpdateAppParams, AppApiItem>(`${ENDPOINTS.APPS}/:id`, '', {
//   withoutNormalize: true,
// });
// export const deleteApp = thunk.delete<DeleteParams, AppApiItem>(`${ENDPOINTS.APPS}/:id`, '', {
//   withoutNormalize: true,
// });
//
